import { DrinkEntity } from "../MealsAndDrinks/DrinkEntity"
import { EProductOrderModeType } from "../../Enum/EProductOrderModeType"
import { GenericOrderFood } from "./GenericOrderFood"

export class OrderDrink extends GenericOrderFood {
  drinkEntityId: number

  drinkEntity: DrinkEntity

  constructor(data: Partial<OrderDrink> = {}) {
    super(data)

    this.drinkEntityId = data.drinkEntityId ?? -1

    this.drinkEntity = new DrinkEntity(data.drinkEntity)
  }

  protected override getJsonFields(): string[] {
    return [...super.getJsonFields(), "drinkEntityId"]
  }

  needKitchen(): boolean {
    return this.drinkEntity.genericFoodEntity.needKitchen
  }

  getName() {
    return this.drinkEntity.genericFoodEntity.name
  }

  getImage() {
    return this.drinkEntity.genericFoodEntity.iconUrl
  }

  getProductOrderMode(): EProductOrderModeType {
    return this.drinkEntity.genericFoodEntity.productOrderMode
  }
}
